import { createContext, useContext } from "react";
import type { BroadcastState } from "../../api/platformBroadcasts";

export type PlatformBroadcastContextValue = {
  state: BroadcastState | null;
  refresh: () => Promise<void>;
  loading: boolean;
};

export const PlatformBroadcastContext =
  createContext<PlatformBroadcastContextValue | null>(null);

export function usePlatformBroadcast() {
  const ctx = useContext(PlatformBroadcastContext);
  return ctx;
}
